import { h } from 'preact'

type RankStyle = {
  isBold: boolean,
  isItalic: boolean,
  isUnderline: boolean,
  color: string
}

interface Props {
  user: {
    rank?: RankStyle,
    userTitle: string
  }
}

const UserName = ({ user }: Props) => {
  const rankClasses = (rank: RankStyle|undefined) => rank
    ? `
  ${rank.isBold ? 'rank--bold' : ''}
  ${rank.isItalic ? 'rank--italic' : ''}
  ${rank.isUnderline ? 'rank--underlined' : ''}
  ` : ''

  return (
    <span className={`${rankClasses(user.rank)}`}
      style={{
        color: user.rank
          ? user.rank.color
          : ''
      }}>
      {user.userTitle}
    </span>
  )
}

export default UserName
